import * as React from 'react'
import { TagDisplayNameSpanConnected } from './TagDisplayNameSpanConnected'
import { Provider } from 'react-redux'
import { mockState, createMockStore } from 'mockState'

export const TagDisplayNameSpanExamples = () => {
  return (
    <div className="TagDisplayNameSpanExamples exampleContainer">
      <h1 className="exampleHeader">default</h1>

      <Provider store={createMockStore(mockState)}>
        <TagDisplayNameSpanConnected taskId="123" tagId="223" />
      </Provider>
    </div>
  )
}
